<ng-container *transloco="let t; prefix: 'notificationBell.menu'">
  <button type="button" class="notification-bell" [matMenuTriggerFor]="menu" (click)="heapTrackOpened()" mat-icon-button>
    <rma-icon
      *rmaLet="total$ as total"
      [class.new]="total > 0"
      [matBadge]="total | LimitDisplayNumber: 50"
      [matBadgeHidden]="total === null || total <= 0"
      glyph="notifications"
      matBadgePosition="after"
      matBadgeColor="accent"
    />
  </button>

  <mat-menu #menu class="notifications-menu" overlayPanelClass="notifications-overlay">
    <ng-template matMenuContent>
      @if (notifications$ | async; as notifications) {
        <div class="scroll-content">
          <div class="heading">
            <span>{{ t('title') }}</span>
            @if (notifications.length > 0) {
              <button type="button" (click)="markAllAsRead()" mat-button color="primary">
                {{ t('markAsRead') }}
              </button>
            }
          </div>
          @if (notifications && notifications.length > 0) {
            <div class="messsages">
              @for (notification of notifications; track notification) {
                <rma-notification-item [notification]="notification" (navigate)="onNavigate(notification, $event)" />
              }
            </div>
          } @else {
            <div class="empty">
              <rma-icon [rounded]="true" glyph="thumb_up" theme="primary" />
              <p>{{ t('empty') }}</p>
            </div>
          }
        </div>
        @if (notifications.length > 0) {
          <div class="actions">
            <a mat-button color="primary" routerLink="/notifications">View all</a>
          </div>
        }
      } @else {
        <div class="heading">{{ t('title') }}</div>
        <div class="empty">
          <mat-spinner class="spinner" [diameter]="30" />
        </div>
      }
    </ng-template>
  </mat-menu>

  <ng-template #empty>
    <div class="empty">
      <rma-icon [rounded]="true" glyph="thumb_up" theme="primary" />
      <p>{{ t('empty') }}</p>
    </div>
  </ng-template>
</ng-container>
